import React, { useEffect, useState } from 'react';
import {
    getCountries,
    getCountryById,
    createCountry,
    updateCountry,
    deleteCountry,
} from '../api/countryService';// check the path!

const CountryPage = () => {
    const [countries, setCountries] = useState([]);
    const [form, setForm] = useState({ name: '' });
    const [editId, setEditId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    useEffect(() => {
        fetchCountries();
    }, []);

    const fetchCountries = async () => {
        setLoading(true);
        try {
            const data = await getCountries();
            setCountries(data);
        } catch (err) {
            setError('Error loading countries');
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        try {
            if (editId) {
                await updateCountry(editId, form);
                setSuccess('Country updated');
            } else {
                await createCountry(form);
                setSuccess('Country created');
            }
            setForm({ name: '' });
            setEditId(null);
            fetchCountries();
        } catch (err) {
            setError('Error saving country');
        }
    };

    const handleEdit = async (id) => {
        try {
            const data = await getCountryById(id);
            setForm({ name: data.name });
            setEditId(id);
        } catch (err) {
            setError('Error loading country');
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Delete this country?')) return;
        try {
            await deleteCountry(id);
            setSuccess('Country deleted');
            fetchCountries();
        } catch (err) {
            setError('Error deleting country');
        }
    };

    return (
        <div className="p-4">
            <h2 className="text-xl font-bold mb-2">Countries</h2>

            <form onSubmit={handleSubmit} className="mb-4 flex gap-2">
                <input
                    type="text"
                    name="name"
                    placeholder="Country Name"
                    value={form.name}
                    onChange={handleChange}
                    className="border p-2 rounded"
                    required
                />
                <button
                    type="submit"
                    className="bg-blue-500 text-white px-4 py-2 rounded"
                >
                    {editId ? 'Update' : 'Add'}
                </button>
                {editId && (
                    <button
                        type="button"
                        onClick={() => { setEditId(null); setForm({ name: '' }); }}
                        className="ml-2 text-gray-500"
                    >
                        Cancel
                    </button>
                )}
            </form>

            {loading && <div>Loading...</div>}
            {error && <div className="text-red-500">{error}</div>}
            {success && <div className="text-green-600">{success}</div>}

            <table className="min-w-full border">
                <thead>
                    <tr>
                        <th className="border px-4 py-2">ID</th>
                        <th className="border px-4 py-2">Name</th>
                        <th className="border px-4 py-2">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {countries.map((country) => (
                        <tr key={country.id}>
                            <td className="border px-4 py-2">{country.id}</td>
                            <td className="border px-4 py-2">{country.name}</td>
                            <td className="border px-4 py-2 flex gap-2">
                                <button
                                    onClick={() => handleEdit(country.id)}
                                    className="bg-yellow-400 text-white px-2 py-1 rounded"
                                >
                                    Edit
                                </button>
                                <button
                                    onClick={() => handleDelete(country.id)}
                                    className="bg-red-500 text-white px-2 py-1 rounded"
                                >
                                    Delete
                                </button>
                            </td>
                        </tr>
                    ))}
                    {countries.length === 0 && (
                        <tr>
                            <td colSpan={3} className="text-center text-gray-500 py-4">
                                No countries found.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default CountryPage;
